/* Gallery lightbox — Polton All Stars.
   Deliberately small: no library, no focus-trap gymnastics beyond what is
   needed to be usable by keyboard. Escape closes, arrows move, the trigger
   gets focus back on close. */
(function () {
  var box = document.querySelector('[data-gal-box]');
  var grid = document.querySelector('[data-gallery]');
  if (!box || !grid) return;

  var img = box.querySelector('[data-gal-img]');
  var cap = box.querySelector('[data-gal-cap]');
  var triggers = Array.prototype.slice.call(grid.querySelectorAll('[data-gal-open]'));
  var index = -1;
  var lastFocused = null;

  if (!triggers.length) return;

  function show(i) {
    if (i < 0) i = triggers.length - 1;
    if (i >= triggers.length) i = 0;
    index = i;
    var t = triggers[i];
    img.src = t.getAttribute('data-full');
    var c = t.getAttribute('data-caption') || '';
    img.alt = c;
    cap.textContent = c;
    cap.hidden = !c;
  }

  function open(i) {
    lastFocused = document.activeElement;
    show(i);
    box.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    box.querySelector('[data-gal-close]').focus();
  }

  function close() {
    box.hidden = true;
    img.src = '';
    document.documentElement.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  triggers.forEach(function (t, i) {
    t.addEventListener('click', function () { open(i); });
  });

  box.querySelector('[data-gal-close]').addEventListener('click', close);
  box.querySelector('[data-gal-prev]').addEventListener('click', function () { show(index - 1); });
  box.querySelector('[data-gal-next]').addEventListener('click', function () { show(index + 1); });

  /* Click the backdrop, not the photo or the controls. */
  box.addEventListener('click', function (e) {
    if (e.target === box) close();
  });

  document.addEventListener('keydown', function (e) {
    if (box.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(index - 1);
    else if (e.key === 'ArrowRight') show(index + 1);
  });
})();
